import React, { useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import messages from './messages';
import useApi from 'hooks/useApi'

const Features = () => {
  const [featureFlags,,, refetch, meta] = useApi('/rest/v2/user/me/features')

  const onFeatureFlagChange = (id, enabled) => {
    const nextFeatureFlags = featureFlags.map((featureFlag) => {
      if (featureFlag.id === id) {
        featureFlag.enabled = enabled
      }

      return featureFlag
    })

    refetch({
      method: 'PUT',
      body: JSON.stringify(nextFeatureFlags)
    })
  }

  useEffect(() => {
    if (meta && meta.requireReload) {
      window.location = '/'
    }
  }, [meta])

  return (
    <div className="mt-10 divide-y divide-gray-200">
      <div className="space-y-1">
        <h3 className="text-lg leading-6 font-medium text-gray-900">
          <FormattedMessage {...messages.title}/>
        </h3>
        <p className="max-w-2xl text-sm text-gray-500">
          <FormattedMessage {...messages.subtitle}/>
        </p>
      </div>
      <div className="mt-6">
        { featureFlags && featureFlags.map(({ id, name, description, enabled }) => (
          <dl key={id} className="divide-y divide-gray-200">
            <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4">
              <dt className="text-sm font-medium text-gray-500">
                { name }
              </dt>
              <dd className="mt-1 flex text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                <span className="grow">{ description }</span>
                <button type="button" onClick={() => onFeatureFlagChange(id, !enabled)} className={`${enabled ? 'bg-primary': 'bg-gray-200'} relative inline-flex shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary sm:ml-auto`} aria-pressed="false" aria-labelledby="auto-update-option-label">
                  <span className="sr-only"><FormattedMessage {...messages.useSetting}/></span>
                  <span aria-hidden="true" className={`${enabled ? 'translate-x-5' :'translate-x-0'} inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200`}></span>
                </button>
              </dd>
            </div>
          </dl>
        )) }
      </div>
    </div>
  )
}

export default Features
